import {Disposable, Environment, commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {CreateSageCompanyInput, CreateSageCompanyMutation} from './__generated__/CreateSageCompanyMutation.graphql';
import RelayEnvironment from '../../../RelayEnvironment';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../ts/MutationTypes';

const mutation = graphql`
	mutation CreateSageCompanyMutation($input: CreateSageCompanyInput!) {
		CreateSageCompany(input: $input) {
			resultCode
			companyId
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CreateSageCompanyInput>,
	onSuccess: RelayOnCompleted<CreateSageCompanyMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(RelayEnvironment.getInstanceMC(), {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
